
  import { Component, Vue, Prop } from 'vue-property-decorator';
  // @ts-ignore
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
  import {
    Heading, Bold, Underline, HardBreak, OrderedList,
    ListItem, Code, Italic, Link, Strike, BulletList, History, Placeholder
  // @ts-ignore
  } from 'tiptap-extensions';

  import EditorMenuButton from './EditorMenuButton.vue';

  Component.registerHooks(['beforeDestroy']);

  @Component({
    components: { Editor, EditorContent, EditorMenuButton, EditorMenuBar },
  })
  export default class EditField extends Vue {
    // TODO i18n
    @Prop({ default: '' }) readonly content!: string;

    get editor() {
      const parent = this;
      return new Editor({
        content: this.content,
        // @ts-ignore
        onUpdate: ({ getHTML }) => {
          parent.$emit('input', getHTML());
        },
        extensions: [
          new HardBreak(),
          new HardBreak(),
          new Link(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Placeholder({
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            emptyNodeText: 'Type your message...',
            showOnlyWhenEditable: true,
            showOnlyCurrent: true,
          }),
        ],
      });
    }

    private beforeDestroy() {
      this.editor.destroy();
    }
  }
